import { OTHER_NODES_LABEL } from "@faire/help-center-self-serve/shared/other-node";
import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Shipping } from "@faire/web/slate/icons/foundation/Shipping";
import React from "react";
import { ApplyForEoriIA } from "../instantAnswers/myAccount-applyForEori";
import { ManageEoriInfoIA } from "../instantAnswers/myAccount-manageEoriInfo";
import { ChargesForDamagedMissingItemsIA } from "../instantAnswers/ordersAndShipping-chargesForDamagedOrMissingItems";
import { CreateReturnIA } from "../instantAnswers/ordersAndShipping-createReturn";
import { DutiesInvoiceIA } from "../instantAnswers/ordersAndShipping-dutiesInvoice";
import { EoriDetailsIA } from "../instantAnswers/ordersAndShipping-eoriDetails";
import { ExtendReturnIA } from "../instantAnswers/ordersAndShipping-extendReturn";
import { HowDutiesWorkIA } from "../instantAnswers/ordersAndShipping-howDutiesWork";
import { ItemDelayedIA } from "../instantAnswers/ordersAndShipping-itemDelayed";
import { ReportDamagedItemIA } from "../instantAnswers/ordersAndShipping-reportDamagedItem";
import { ReportMissingItemIA } from "../instantAnswers/ordersAndShipping-reportMissingItem";
import { ReportWrongItemIA } from "../instantAnswers/ordersAndShipping-reportWrongItem";
import { RequestDutiesReimbursementIA } from "../instantAnswers/ordersAndShipping-requestDutiesReimbursement";
import { ShippingCostEstimatesIA } from "../instantAnswers/ordersAndShipping-shippingCostEstimates";
import { UpdateAccountShippingAddressIA } from "../instantAnswers/ordersAndShipping-updateAccountShippingAddress";
import { WhereIsMyOrderIA } from "../instantAnswers/ordersAndShipping-whereIsMyOrder";
import { GeneralContactBrandIA } from "../instantAnswers/shared-generalContactBrand";
import { ManageEoriInfoVisibilityFn } from "../visibilityFunctions/manageEoriInfoVisibilityFn";
export var useOrdersRetailerNodes = function useOrdersRetailerNodes() {
  var _articles$ImportFeesA, _articles$FAQ$FAIRE_I;
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var articles = useArticles();
  return {
    Orders: {
      id: "Orders",
      label: strictLocalize({
        id: "DPqb3A",
        defaultMessage: [{
          "type": 0,
          "value": "Commandes"
        }]
      }),
      icon: /*#__PURE__*/React.createElement(Shipping, {
        fontSize: "24px",
        color: "faireBlack"
      }),
      children: ["TrackOrder", "EditOrder", "InternationalShippingAndCustoms", "ShippingCosts", "OrderIssues", "DamagedOrMissingItems", "Returns"],
      level: 1,
      sidebarTitle: strictLocalize({
        id: "YtMFge",
        defaultMessage: [{
          "type": 0,
          "value": "Problème de commandes"
        }]
      })
    },
    TrackOrder: {
      id: "TrackOrder",
      label: strictLocalize({
        id: "7zl4u3",
        defaultMessage: [{
          "type": 0,
          "value": "Suivre la commande"
        }]
      }),
      instantAnswer: WhereIsMyOrderIA(strictLocalize),
      level: 2
    },
    EditOrder: {
      id: "EditOrder",
      label: strictLocalize({
        id: "/NhbPa",
        defaultMessage: [{
          "type": 0,
          "value": "Modifier la commande"
        }]
      }),
      children: ["UpdateShippingAddress"],
      level: 2
    },
    InternationalShippingAndCustoms: {
      id: "InternationalShippingAndCustoms",
      label: strictLocalize({
        id: "LKsVBp",
        defaultMessage: [{
          "type": 0,
          "value": "Expédition internationale et douanes"
        }]
      }),
      children: ["Duties", "EORI", "AboutImportingProducts", "OtherInternationalShippingAndCustoms"],
      level: 2
    },
    ShippingCosts: {
      id: "ShippingCosts",
      label: strictLocalize({
        id: "L3Y+9t",
        defaultMessage: [{
          "type": 0,
          "value": "Frais de livraison"
        }]
      }),
      children: ["ShippingCostEstimates", "ShippingCostsWithInsider", "OtherShippingCosts"],
      level: 2
    },
    OrderIssues: {
      id: "OrderIssues",
      label: strictLocalize({
        id: "YHlFtr",
        defaultMessage: [{
          "type": 0,
          "value": "Problèmes de commande"
        }]
      }),
      children: ["OrderDelayed", "ReturnedToSender"],
      level: 2
    },
    DamagedOrMissingItems: {
      id: "DamagedOrMissingItems",
      label: strictLocalize({
        id: "AwhDKj",
        defaultMessage: [{
          "type": 0,
          "value": "Articles endommagés ou manquants"
        }]
      }),
      children: ["ReportDamagedItems", "ReportMissingItems", "WrongItemsSent", "ChargesForDamagedOrMissingItems", "OtherDamagedMissingOrWrong"],
      level: 2
    },
    Returns: {
      id: "Returns",
      label: strictLocalize({
        id: "+Ft0jF",
        defaultMessage: [{
          "type": 0,
          "value": "Retours"
        }]
      }),
      children: ["StartAReturn", "ExtendReturnWindow", "OtherReturns"],
      level: 2
    },
    UpdateShippingAddress: {
      id: "UpdateShippingAddress",
      label: strictLocalize({
        id: "ht5qXQ",
        defaultMessage: [{
          "type": 0,
          "value": "Mettre à jour l'adresse de livraison sur le compte"
        }]
      }),
      articles: [articles.FulfillingOrders.SHIPPING_ADDRESS],
      instantAnswer: UpdateAccountShippingAddressIA(strictLocalize),
      level: 3
    },
    StartAReturn: {
      id: "StartAReturn",
      label: strictLocalize({
        id: "3zy58Y",
        defaultMessage: [{
          "type": 0,
          "value": "Commencer une procédure de retour"
        }]
      }),
      articles: [articles.ReturnsAndRefunds.MAKE_A_RETURN, articles.ReturnsAndRefunds.CANT_RETURN],
      instantAnswer: CreateReturnIA(strictLocalize),
      level: 3
    },
    ExtendReturnWindow: {
      id: "ExtendReturnWindow",
      label: strictLocalize({
        id: "UvRR6c",
        defaultMessage: [{
          "type": 0,
          "value": "Prolonger le délai de retour"
        }]
      }),
      articles: [articles.ReturnsAndRefunds.EXTEND_A_RETURN],
      instantAnswer: ExtendReturnIA(strictLocalize),
      level: 3
    },
    OtherReturns: {
      id: "OtherReturns",
      label: OTHER_NODES_LABEL(strictLocalize),
      articles: [articles.ReturnsAndRefunds.MAKE_A_RETURN],
      instantAnswer: GeneralContactBrandIA(strictLocalize),
      level: 3
    },
    ReportDamagedItems: {
      id: "ReportDamagedItems",
      label: strictLocalize({
        id: "T0T0mD",
        defaultMessage: [{
          "type": 0,
          "value": "Signaler des articles endommagés"
        }]
      }),
      articles: [articles.MyOrders.REPORT_DAMAGED_MISSING],
      instantAnswer: ReportDamagedItemIA(strictLocalize),
      level: 3
    },
    ReportMissingItems: {
      id: "ReportMissingItems",
      label: strictLocalize({
        id: "+umDSU",
        defaultMessage: [{
          "type": 0,
          "value": "Signaler des articles manquants"
        }]
      }),
      articles: [articles.MyOrders.REPORT_DAMAGED_MISSING],
      instantAnswer: ReportMissingItemIA(strictLocalize),
      level: 3
    },
    WrongItemsSent: {
      id: "WrongItemsSent",
      label: strictLocalize({
        id: "x13QnE",
        defaultMessage: [{
          "type": 0,
          "value": "Les articles envoyés ne correspondent pas à la commande"
        }]
      }),
      articles: [articles.MyOrders.REPORT_DAMAGED_MISSING],
      instantAnswer: ReportWrongItemIA(strictLocalize),
      level: 3
    },
    ChargesForDamagedOrMissingItems: {
      id: "ChargesForDamagedOrMissingItems",
      label: strictLocalize({
        id: "c0/hvZ",
        defaultMessage: [{
          "type": 0,
          "value": "Frais pour articles manquants ou endommagés"
        }]
      }),
      articles: [articles.MyOrders.REPORT_DAMAGED_MISSING],
      instantAnswer: ChargesForDamagedMissingItemsIA(strictLocalize),
      level: 3
    },
    OtherDamagedMissingOrWrong: {
      id: "OtherDamagedMissingOrWrong",
      label: OTHER_NODES_LABEL(strictLocalize),
      articles: [articles.MyOrders.REPORT_DAMAGED_MISSING],
      instantAnswer: GeneralContactBrandIA(strictLocalize),
      level: 3
    },
    OrderDelayed: {
      id: "OrderDelayed",
      label: strictLocalize({
        id: "JeRLEJ",
        defaultMessage: [{
          "type": 0,
          "value": "Commande en retard"
        }]
      }),
      articles: [articles.MyOrders.ORDER_STATUS],
      instantAnswer: ItemDelayedIA(strictLocalize),
      level: 3
    },
    ReturnedToSender: {
      id: "ReturnedToSender",
      label: strictLocalize({
        id: "Yc0H12",
        defaultMessage: [{
          "type": 0,
          "value": "Colis retourné à l'expéditeur"
        }]
      }),
      articles: [articles.ReturnsAndRefunds.MAKE_A_RETURN],
      instantAnswer: GeneralContactBrandIA(strictLocalize),
      level: 3
    },
    ShippingCostEstimates: {
      id: "ShippingCostEstimates",
      label: strictLocalize({
        id: "SS+oQb",
        defaultMessage: [{
          "type": 0,
          "value": "Comprendre les estimations des frais de livraison"
        }]
      }),
      articles: [articles.FulfillingOrders.SHIPPING_WORK],
      instantAnswer: ShippingCostEstimatesIA(strictLocalize),
      level: 3
    },
    ShippingCostsWithInsider: {
      id: "ShippingCostsWithInsider",
      label: strictLocalize({
        id: "5ak7Xv",
        defaultMessage: [{
          "type": 0,
          "value": "Frais de livraison avec Insider"
        }]
      }),
      articles: [articles.FAQ.FAIRE_INSIDER_EU, articles.FAQ.FAIRE_INSIDER_US],
      level: 3
    },
    OtherShippingCosts: {
      id: "OtherShippingCosts",
      label: OTHER_NODES_LABEL(strictLocalize),
      articles: [articles.FulfillingOrders.SHIPPING_WORK],
      level: 3
    },
    Duties: {
      id: "Duties",
      label: strictLocalize({
        id: "X0Xj++",
        defaultMessage: [{
          "type": 0,
          "value": "Droits de douane"
        }]
      }),
      level: 3,
      children: ["AboutDuties", "DutiesNotice", "RequestDutiesReimbursement", "OtherInternationalShippingAndCustomsDuties"]
    },
    EORI: {
      id: "EORI",
      label: strictLocalize({
        id: "5x/o6P",
        defaultMessage: [{
          "type": 0,
          "value": "EORI"
        }]
      }),
      children: ["AboutEORI", "ApplyForEORI", "ManageEORI"],
      level: 3
    },
    AboutImportingProducts: {
      id: "AboutImportingProducts",
      label: strictLocalize({
        id: "1PTzQL",
        defaultMessage: [{
          "type": 0,
          "value": "À propos de l'importation de produits"
        }]
      }),
      articles: [articles.ImportFeesAndDuties.USA, articles.ImportFeesAndDuties.Canada, articles.ImportFeesAndDuties.Europe, articles.ImportFeesAndDuties.Australia],
      instantAnswer: GeneralContactBrandIA(strictLocalize),
      level: 3
    },
    OtherInternationalShippingAndCustoms: {
      id: "OtherInternationalShippingAndCustoms",
      label: OTHER_NODES_LABEL(strictLocalize),
      articles: [articles.ImportFeesAndDuties.DUTIES_REFUND],
      level: 3
    },
    ApplyForEORI: {
      id: "ApplyForEORI",
      label: strictLocalize({
        id: "cFoITi",
        defaultMessage: [{
          "type": 0,
          "value": "Demander un numéro EORI"
        }]
      }),
      instantAnswer: ApplyForEoriIA(strictLocalize, articles),
      isNodeVisible: ManageEoriInfoVisibilityFn,
      level: 4
    },
    ManageEORI: {
      id: "ManageEORI",
      label: strictLocalize({
        id: "H06O85",
        defaultMessage: [{
          "type": 0,
          "value": "Gérer l'EORI"
        }]
      }),
      instantAnswer: ManageEoriInfoIA(strictLocalize),
      isNodeVisible: ManageEoriInfoVisibilityFn,
      level: 4
    },
    AboutEORI: {
      id: "AboutEORI",
      label: strictLocalize({
        id: "u01v/g",
        defaultMessage: [{
          "type": 0,
          "value": "Détails EORI"
        }]
      }),
      articles: [articles.ImportFeesAndDuties.EORI],
      instantAnswer: EoriDetailsIA(strictLocalize),
      level: 4
    },
    AboutDuties: {
      id: "AboutDuties",
      label: strictLocalize({
        id: "U6y6Ei",
        defaultMessage: [{
          "type": 0,
          "value": "À propos des droits de douane"
        }]
      }),
      articles: [articles.ImportFeesAndDuties.DUTIES_REFUND],
      instantAnswer: HowDutiesWorkIA(strictLocalize, articles),
      level: 4
    },
    DutiesNotice: {
      id: "DutiesNotice",
      label: strictLocalize({
        id: "f5s2Yp",
        defaultMessage: [{
          "type": 0,
          "value": "Avis de droits de douane"
        }]
      }),
      articles: [(_articles$ImportFeesA = articles.ImportFeesAndDuties.DUTIES_REFUND) === null || _articles$ImportFeesA === void 0 ? void 0 : _articles$ImportFeesA.atSection("0"), (_articles$FAQ$FAIRE_I = articles.FAQ.FAIRE_INSIDER_EU) === null || _articles$FAQ$FAIRE_I === void 0 ? void 0 : _articles$FAQ$FAIRE_I.atSection("6")],
      instantAnswer: DutiesInvoiceIA(strictLocalize),
      level: 4
    },
    RequestDutiesReimbursement: {
      id: "RequestDutiesReimbursement",
      label: strictLocalize({
        id: "Audzui",
        defaultMessage: [{
          "type": 0,
          "value": "Demander le remboursement des droits de douane"
        }]
      }),
      articles: [articles.ImportFeesAndDuties.DUTIES_REFUND],
      instantAnswer: RequestDutiesReimbursementIA(strictLocalize, articles),
      level: 4
    },
    OtherInternationalShippingAndCustomsDuties: {
      id: "OtherInternationalShippingAndCustomsDuties",
      label: OTHER_NODES_LABEL(strictLocalize),
      articles: [articles.ImportFeesAndDuties.DUTIES_REFUND],
      level: 4
    }
  };
};